import React from 'react'
import { ServerConfig } from 'config'

import NonPaginatedList from '../../components/EntryListAndEdit/NonPaginatedList'
import AtmDeviceAddComponent from './AtmDeviceAddComponent'


const AtmDevices = () => {
  // tenant_id is intentionally NOT editable here: the backend
  // (update_atm_device) blocks changing it via PUT, since tenant_site_id is
  // validated against the device's tenant at creation time and allowing an
  // admin to silently move a device to a different tenant afterward could
  // leave that relationship inconsistent. Shown read-only instead.
  const non_editable_fields = [
    ["id", "id", ""],
    ["tenant_id", "Tenant", ""],
  ];

  // secret_hash is never editable or even fetchable here - the backend
  // never returns it, and PUT explicitly rejects it. The plaintext secret
  // can only ever be seen once, at creation time (see AtmDeviceAddComponent).
  const editable_fields = [
    ["name", "Name"],
    ["tenant_site_id", "Tenant Site", "tenantsite"],
    ["active", "Active", "boolean"],
  ];

  return (
    <>
      <NonPaginatedList
        list_get_url={`${ServerConfig.SERVER_URL}/admin/atm_devices`}
        detail_get_url={`${ServerConfig.SERVER_URL}/admin/atm_devices/`}
        detail_put_url={`${ServerConfig.SERVER_URL}/admin/atm_devices/`}
        // no add_new_url here on purpose - creation needs to reveal the
        // generated client_secret once, which NonPaginatedList's generic
        // AddComponent has no way to do, so it's handled by the separate
        // AtmDeviceAddComponent below instead

        column_names={["id", "name", "tenant_id", "tenant_site_id", "active", "edit"]}
        header_names={["id", "name", "tenant_id", "tenant_site_id", "active", ""]}

        optional_column_names={["tenant_site_id", "active"]}
        optional_header_names={["tenant_site_id", "active"]}

        editable_fields={editable_fields}
        non_editable_fields={non_editable_fields}
      />

      <AtmDeviceAddComponent add_new_url={`${ServerConfig.SERVER_URL}/admin/atm_devices/`} />
    </>
  )
}

export default AtmDevices
